export default __webpack_public_path__ + "static/media/PeeCeeB@3x.d4cb793e.png";